@if (!readonly) {
    <mat-form-field class="flex" [ngClass]="{ 'cb-soft-required': softRequired && !required }">
        <mat-label>{{ label }}</mat-label>
        <!-- Optional Prefix Icons -->
        @if (svgIcon) {
            <mat-icon [svgIcon]="svgIcon" matPrefix class="cb-margin-right"></mat-icon>
        }
        @if (icon) {
            <mat-icon matPrefix class="cb-margin-right">{{ icon }}</mat-icon>
        }
        <!-- Input Field -->
        <input
            matInput
            class="input"
            [name]="internalName"
            [(ngModel)]="value"
            [ignoreDirty]="ignoreDirty"
            [type]="type"
            [min]="minimum"
            [max]="maximum"
            [required]="required"
            [email]="type === 'email'"
            [maxlength]="maxlength"
            [autocomplete]="autocomplete"
            [pattern]="pattern"
            [disabled]="disabled"
            [maskType]="maskType"
            (ngModelChange)="modelChanged ? modelChanged($event) : null"
            (keydown.enter)="enterPressed($event)"
            [ngStyle]="suffixWidth ? { 'padding-right': suffixWidth + 'px' } : null"
        />
        <!-- Suffix -->
        <span #suffixEle matSuffix class="suffix mat-body-1">{{ suffix }}</span>
    </mat-form-field>
}

<!-- Readonly Display -->
@if (readonly) {
    <cb-display-value-new [label]="label">
        <div class="start-center flex-row">
            <!-- Optional Icons -->
            @if (icon || svgIcon) {
                <div class="flex-col">
                    @if (svgIcon) {
                        <mat-icon [svgIcon]="svgIcon" class="cb-margin-right"></mat-icon>
                    }
                    @if (icon) {
                        <mat-icon class="cb-margin-right">{{ icon }}</mat-icon>
                    }
                </div>
            }
            <!-- Value and Suffix -->
            <div class="flex flex-row start-center">
                <div>{{ value }}</div>
                <span>{{ suffix }}</span>
            </div>
        </div>
    </cb-display-value-new>
}
